var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row list-view"
  }, [_c('div', {
    staticClass: "row p6 radius6 animate-bottom"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('header', {
    staticClass: "row p12 list-view-filter",
    staticStyle: {
      "background": "#f2f2f2"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "h-filter"
  }, [_c('div', {
    staticClass: "h-filter-item",
    staticStyle: {
      "min-width": "40px",
      "width": "fit-content"
    }
  }, [_c('div', {
    staticClass: "filter-action filter-af",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "7px"
    }
  }, [_vm.checkoutPermission('CREATE_WAREHOUSE') ? _c('button', {
    staticClass: "btn btn-success btn-sm ah mt8",
    on: {
      "click": function ($event) {
        return _vm.linkPage('CreateWarehouse');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New ")]) : _vm._e()])])])]), _c('div', {
    staticClass: "table-control"
  }, [_c('table', {
    staticClass: "table wh800",
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w50 txt-center"
  }, [_vm._v("No")]), _c('th', {
    attrs: {
      "width": "150px"
    }
  }, [_vm._v("Name")]), _c('th', {
    attrs: {
      "width": "150px"
    }
  }, [_vm._v("Code")]), _c('th', {
    attrs: {
      "width": "300px"
    }
  }, [_vm._v("Description")]), _vm.checkoutPermission('UPDATE_WAREHOUSE') || _vm.checkoutPermission('DELETE_WAREHOUSE') ? _c('th', {
    staticClass: "w100 txt-center"
  }, [_vm._v(" Action ")]) : _vm._e()])]), _vm.checkoutPermission('VIEW_WAREHOUSE') ? _c('tbody', _vm._l(_vm.data.items, function (item, index) {
    return _c('tr', {
      key: (item, index),
      staticClass: "hover-list"
    }, [_c('td', {
      staticClass: "txt-center"
    }, [_vm._v(" " + _vm._s(String((_vm.data.pagination.offset || 0) + index + 1).padStart(3, '0')) + " ")]), _c('td', [_vm._v(_vm._s(item.name || "N/A"))]), _c('td', [_vm._v(_vm._s(item.code || "N/A"))]), _c('td', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.description || "N/A"))]), _c('td', {
      staticClass: "txt-center"
    }, [_vm.checkoutPermission('UPDATE_WAREHOUSE') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'EditWarehouse',
          query: {
            id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-info btn-xs h36"
    }, [_c('i', {
      staticClass: "fa fa-pen"
    })])]) : _vm._e(), _vm.checkoutPermission('DELETE_WAREHOUSE') ? _c('button', {
      staticClass: "btn btn-danger btn-xs h36 ml3",
      on: {
        "click": function ($event) {
          return _vm.popupModalDelete(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()], 1)]);
  }), 0) : _vm._e()]), _vm.isFetching ? _c('TableLoading') : _vm._e(), !_vm.isFetching && _vm.data.items.length <= 0 ? _c('NoItem') : _vm._e()], 1), _c('div', {
    staticClass: "total ph12"
  }, [_c('div', {
    staticClass: "ul-xl-li go-left"
  }, [_vm._v("Total : " + _vm._s(_vm.data.pagination.total))]), _vm.data.pagination.totalPage ? _c('Pagination', {
    attrs: {
      "pagination": _vm.data.pagination.totalPage
    }
  }) : _vm._e()], 1)])]), _vm.display.modal.delete.show ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.closeModal
    }
  }), _c('div', {
    staticClass: "modal-md"
  }, [_vm._m(1), _vm._m(2), _c('div', {
    staticClass: "modal-footer border-top"
  }, [!_vm.isDeleting ? _c('button', {
    staticClass: "btn btn-info btn-xs go-right",
    staticStyle: {
      "width": "75px"
    },
    on: {
      "click": _vm.deleteWarehouse
    }
  }, [_vm._v(" Yes ")]) : _c('button', {
    staticClass: "btn btn-info btn-xs go-right",
    staticStyle: {
      "width": "75px"
    }
  }, [_vm._v(" Loading... ")]), _c('button', {
    staticClass: "btn btn-light-secondary btn-xs go-right mr12",
    staticStyle: {
      "width": "75px"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" No ")])])])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "go-left"
  }, [_c('b', [_vm._v("Warehouses")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-header border-bottom txt-info"
  }, [_c('span', {
    staticClass: "txt-sm"
  }, [_vm._v("Delete")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "hidden",
      "padding": "16px"
    }
  }, [_c('span', [_vm._v("Do you want to delete this record?")])]);

}]

export { render, staticRenderFns }